import {Component} from "@angular/core";
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import { UserStore } from "@digicerba/common";


@Component({
    selector: 'mode-paiement',
    templateUrl: './mode-paiement.component.html',
  host: {'class': 'page'}
})
export class ModePaiementComponent {
  userAnglais: boolean;

  constructor(private router: Router, private userStore: UserStore, private translate: TranslateService) {
  }

  ngOnInit() {
    if (this.userStore.getUser().lang === 'en') {
      this.userAnglais = true;
      this.translate.setDefaultLang('en');
    } else {
      this.userAnglais = false;
      this.translate.setDefaultLang('fr');
    }
  }

    goPaiement() {
        this.router.navigate(['cerba/paiement-patient']);
    }

  goPaiementLabo() {
    this.router.navigate(['cerba/paiement-laboratoire']);
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-paiement-factures/digicerba-paiement-factures-web/src/angular/cerba/src/app/pages/cerba/pages/mode-paiement/mode-paiement.component.ts